/** @jsxImportSource @emotion/react */
import React, { useState } from "react";
import { toast } from "react-toastify";
import { useRecoilState, useSetRecoilState } from "recoil";
import {
  addEmailRestrictions,
  getEmailRestrictions,
} from "../../../../api/User";
import { UserAtom } from "../../../../atoms/UserAtom";
import { UserEmailRestrictionsAtom } from "../../../../atoms/UserEmailRestrictionsAtom";
import StyledBlockInput, { BlockInputType } from "../../../StyledBlockInput";

const validationRegex = /[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}/;

export default function BlockDeviceIP() {
  const [isLoading, setIsLoading] = useState(false);
  const setEmailRestrictions = useSetRecoilState(UserEmailRestrictionsAtom);
  const [user, setUser] = useRecoilState(UserAtom);

  async function handleBlockDomain(deviceIps: string[]) {
    setIsLoading(true);

    try {
      await addEmailRestrictions({ deviceIpsBlocked: deviceIps });
      toast("Success", { type: "success" });
      const emailRestrictions = await getEmailRestrictions();
      setEmailRestrictions(emailRestrictions);
      setUser({ ...user, emailRestrictions });
    } catch {
      toast("Error", { type: "error" });
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <StyledBlockInput
      handleClick={handleBlockDomain}
      isLoading={isLoading}
      inputType={BlockInputType.DeviceIP}
      replaceAll={(value: string) => {
        const x = value
          .replace(/\D/g, "")
          .match(/(\d{0,3})(\d{0,3})(\d{0,3})(\d{0,3})/);

        if (!x) return value;

        let formattedIp =
          +x[1] +
          (x[1].length === 3 && ".") +
          (x[2] && x[2].length === 3 ? x[2] + "." : x[2]) +
          (x[3] && x[3].length === 3 ? x[3] + "." : x[3]) +
          x[4];

        if (value === "") formattedIp = "";
        return formattedIp;
      }}
      placeholder="Enter device IP"
      isValid={(value: string) => {
        const isValid = value.match(validationRegex);
        if (!isValid) return `${value} is not a valid ip.`;
        return "";
      }}
    />
  );
}
